<template>
  <div class="hello">
    <div class="container-fluid">
      <div class="logo"></div>
      <div class="tarja mt-5 text-center">Plataforma em construção</div>

      <div class="row justify-content-center mt-5">
        <div class="col col-lg-1 text-center">
          <a href="https://www.instagram.com/tribodosucuriu/" target="_blank">
            <div class="icon instagram"></div>
          </a>
        </div>

        <div class="col col-lg-1 text-center">
          <a href="https://www.facebook.com/tribodosucuriu" target="_blank">
            <div class="icon facebook"></div>
          </a>
        </div>

        <div class="col col-lg-1 text-center">
          <a href="https://www.linkedin.com/company/tribodosucuriu/" target="_blank">
            <div class="icon linkedin"></div>
          </a>
        </div>

        <div class="col col-lg-1 text-center">
          <a href="https://wa.me/5567999054558" target="_blank">
            <div class="icon whatsapp"></div>
          </a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>


